<template>
  <div>
    <br>
    <br>&nbsp;&nbsp;&nbsp;&nbsp;
    <label style="font-size: 30px">哦豁，这个页面没有找到,找他们算账！！</label>
  </div>
</template>

<script>
    export default {
        name: "Error404"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/error/Error404.vue